import { useCallback, useState } from "react";
import { useAuthContext } from "@app/authContext";
import { FileItem } from "@services/api";

const BASE_URL: string = (window as any).FZ_API_BASE_URL;

export function useUploadFile() {
  const { auth } = useAuthContext();
  const accessToken = auth?.access_token ?? "";
  const [loading, setLoading] = useState(false);

  const upload = useCallback(
    async (file: File): Promise<FileItem> => {
      const formData = new FormData();
      formData.append("file", file);

      try {
        setLoading(true);
        const res = await fetch(`${BASE_URL}/front-agent/document/file`, {
          method: "POST",
          headers: accessToken ? { Authorization: `Bearer ${accessToken}` } : undefined,
          body: formData,
        });

        if (!res.ok) {
          throw new Error(`Upload failed with status ${res.status}`);
        }

        const json = (await res.json()) as FileItem;
        // ожидается: { fileId, fileName, size }
        return json;
      } finally {
        setLoading(false);
      }
    },
    [accessToken]
  );

  return { upload, loading };
}
